import React from "react";

export const AcceptIcon = () => (
  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="12.1738" y="3.39746" width="11.0768" height="1.81838" rx="0.909191" transform="rotate(127.509 12.1738 3.39746)" fill="#6FC56F"/>
    <rect x="1.58008" y="6.13538" width="6.85603" height="1.81838" rx="0.909191" transform="rotate(43.9669 1.58008 6.13538)" fill="#6FC56F"/>
  </svg>
)
